import { render, staticRenderFns } from "./commission-item.vue?vue&type=template&id=29e7cbb8&"
import script from "./commission-item.vue?vue&type=script&lang=js&"
export * from "./commission-item.vue?vue&type=script&lang=js&"
import style0 from "./commission-item.vue?vue&type=style&index=0&id=29e7cbb8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports